import React, { useState, useEffect } from 'react'
import CustomModal from 'components/commons/CustomModal'
import ErrorIcon from '@material-ui/icons/Error'
import questionnaireStyles from '../CreateQuestionnaire/styles'
import { useHistory } from 'react-router-dom'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import { postToApi } from 'actions'
import TooltipInputError from 'components/toolTip/ToolTipInputError'
import { Controller, useForm } from 'react-hook-form'
import { useStateValue } from 'context/store'
import {
   Checkbox,
   Button,
   FormControl,
   Grid,
   makeStyles,
   FormControlLabel,
   Paper,
   TextField
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
const useStyles = makeStyles(theme => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3)
   }
}))

function ConfirmationModal({
   showComfirmationModal,
   setShowComfirmationModal,
   data = {}
}) {
   const classesModal = useStyles()
   const history = useHistory()
   const [_, dispatch] = useStateValue()
   const classes = questionnaireStyles()
   const {
      watch,
      handleSubmit,
      control,
      formState: { errors, isValid },
      setValue
   } = useForm({
      defaultValues: {
         name: '',
         questions: false
      },
      mode: 'onChange'
   })
   useEffect(() => {
      setValue('name', `Copia de ${data?.name}`)
   }, [data])

   const fetchCopy = async question => {
      const payload = {
         questionareId: data.id,
         newName: question.name,
         question: question.questions
      }
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/duplicate`
      try {
         const searchedQuestionnaires = await postToApi(url, payload)
         dispatch({
            type: 'OPEN_SNACKBAR',
            openMessage: {
               open: true,
               message: `Cuestionario duplicado exitosamente`,
               severity: 'success'
            }
         })
      } catch (error) {
         dispatch({
            type: 'OPEN_SNACKBAR',
            openMessage: {
               open: true,
               message: ` Ocurrio un error al intentar enviar el cuestionario: ${error?.data?.message}`,
               severity: 'error'
            }
         })
      }
      setShowComfirmationModal(false)
   }
   return (
      <Modal
         open={showComfirmationModal}
         className={classesModal.modal}
         aria-labelledby="spring-modal-title"
         aria-describedby="spring-modal-description"
         onClose={() => setShowComfirmationModal(false)}
         BackdropComponent={Backdrop}
         closeAfterTransition
         BackdropProps={{
            timeout: 500
         }}
      >
         <div className={classesModal.paper} style={{ position: 'relative' }}>
            <CloseIcon
               style={{ fontSize: 25, position: 'absolute', right: '10px' }}
               onClick={() => setShowComfirmationModal(false)}
            />
            <form onSubmit={handleSubmit(d => fetchCopy(d))}>
               <Grid className={classes.confirmModalContainer}>
                  <div
                     style={{
                        alignSelf: 'start',
                        marginBottom: 16,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10
                     }}
                  >
                     <FileCopyIcon style={{ color: '#3264DC', fontSize: 25 }} />
                     <h3> Copiar cuestionario </h3>
                  </div>
                  <div>
                     <FormControl fullWidth>
                        <Controller
                           name="name"
                           control={control}
                           rules={{
                              required: {
                                 value: true,
                                 message: 'El titulo es obligatorio'
                              },
                              maxLength: {
                                 value: 150,
                                 message:
                                    'El Número de Caracteres NO es válido. '
                              }
                           }}
                           render={({
                              field: { value, onChange, onBlur },
                              fieldState: { error }
                           }) => (
                              <TextField
                                 label="Título *"
                                 value={value}
                                 onChange={onChange}
                                 onBlur={onBlur}
                                 error={errors?.name}
                                 variant="outlined"
                                 style={{ minWidth: 600 }}
                                 InputProps={{
                                    endAdornment: errors?.name?.type ===
                                       'maxLength' && (
                                       <TooltipInputError
                                          title={`El número permitido de caracteres es de máximo 150.`}
                                       />
                                    )
                                 }}
                                 // size="small"
                                 margin="normal"
                                 helperText={
                                    errors?.name ? errors.name?.message : ''
                                 }
                              />
                           )}
                        />
                     </FormControl>
                     <FormControl
                        style={{
                           display: 'flex',
                           flexDirection: 'row',
                           alignItems: 'center',
                           marginTop: 20
                        }}
                     >
                        <Controller
                           name="questions"
                           control={control}
                           render={({ field: props }) => (
                              <FormControlLabel
                                 control={
                                    <Checkbox
                                       color="primary"
                                       {...props}
                                       checked={props.value}
                                       onChange={e =>
                                          props.onChange(e.target.checked)
                                       }
                                       name="gilad"
                                    />
                                 }
                                 label="Copiar con todas las preguntas"
                              />
                           )}
                        />
                     </FormControl>
                  </div>
                  <div className={classes.modalButtonsContainer}>
                     <Button
                        style={{ margin: '0 10px 0 10px' }}
                        disableElevation
                        color="primary"
                        onClick={() => setShowComfirmationModal(false)}
                     >
                        CANCELAR
                     </Button>
                     <Button
                        style={{ margin: '0 10px 0 10px' }}
                        variant="contained"
                        disableElevation
                        color="primary"
                        type="submit"
                     >
                        CREAR UNA COPIA
                     </Button>
                  </div>
               </Grid>
            </form>
         </div>
      </Modal>
   )
}

export default ConfirmationModal
